import customAxios from "../../customAxios";
import { WITHDRAWAL_APPROVE, WITHDRAWAL_DISAPPROVE } from "../../routes";

const disApproveWithdrawal = async (
  withdrawalId: string,
  description: string
) => {
  const body = {
    withdrawalId,
    description,
  };
  try {
    return (await customAxios.put(WITHDRAWAL_DISAPPROVE, body)).data;
  } catch (error: unknown) {
    console.error({ APPROVE_DRIVER: error });
    return false;
  }
};

export default disApproveWithdrawal;
